module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/done-circle-478d7225368dec8a56510467ec62dcbe.svg";